module.exports = {"TXTMOB_Search_by_PokerStars_ID":{"id":"TXTMOB_Search_by_PokerStars_ID","defaultMessage":"Rechercher par nom d''utilisateur"}}